/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the display of the
 * 3 Advertisment set up in administration panel
 */

// Imports
import PropTypes from "prop-types";

// Interfaces
import { Advertisement, PublicCabinet } from '../../interfaces/ICabinets';

export const Advertising = (props) => {
    const cabinet = JSON.parse(localStorage.getItem('cabinet') || "{}") as PublicCabinet;
    const ad1 = cabinet?.advertisement1?.image ? cabinet.advertisement1 : {} as Advertisement;
    const ad2 = cabinet?.advertisement2?.image ? cabinet.advertisement2 : {} as Advertisement;
    const ad3 = cabinet?.advertisement3?.image ? cabinet.advertisement3 : {} as Advertisement;
        

    return (
        <div className={`flex flex-row w-full justify-between bc-advertissement px-4 ${props.className}`}>
            
            {/* Advertissement 1 */}
            <a tabIndex={97} href={`${ad1.url ? ad1.url : '#'}`} target={`${ad1.url ? '_blank' : ''}`} className={`w-[30%] ${!ad1.image ? 'hidden' : ''}`}>
                <img src={ad1.image} alt="Advertissement 1" className="h-full w-full object-contain object-center m-auto max-w-[100%] max-h-[100%]" />
            </a>
            
            {/* Advertissement 2 */}
            <a tabIndex={98} href={`${ad2.url ? ad2.url : '#'}`} target={`${ad2.url ? '_blank' : ''}`} className={`w-[30%] ${!ad2.image ? 'hidden' : ''}`} >
                <img src={ad2.image} alt="Advertissement 2" className="h-full w-full object-contain object-center m-auto max-w-[100%] max-h-[100%]" />
            </a>

            {/* Advertissement 3 */}
            <a tabIndex={99} href={`${ad3.url ? ad3.url : '#'}`} target={`${ad3.url ? '_blank' : ''}`} className={`w-[30%] ${!ad3.image ? 'hidden' : ''}`}>
                <img src={ad3.image} alt="Advertissement 3" className="h-full w-full object-contain object-center m-auto max-w-[100%] max-h-[100%]" />
            </a>
        </div>
    );
}

Advertising.propTypes = {
    className: PropTypes.string
}